require('./transfersAddBeneficiaryView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
// @ commons
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const WizardError = require('components/commons/wizardError/wizardError');
// @ actions
const beneficiariesActions = require('actions/beneficiaries');
const addBeneficiaryActions = require('actions/addBeneficiary');
const printerActions = require('actions/contactCenter/printer');
const bankEntityActions = require('actions/bankEntity');
// @ components
const {
    AddBeneficiaryStep1
} = require('components/transfers/transfersAgenda/addBeneficiary/addBeneficiaryStep1/addBeneficiaryStep1');
const AddBeneficiaryStep2 = require('components/transfers/transfersAgenda/addBeneficiary/addBeneficiaryStep2/addBeneficiaryStep2');
const AddBeneficiarySuccessStep = require('components/transfers/transfersAgenda/addBeneficiary/addBeneficiarySuccessStep/addBeneficiarySuccessStep');
const { LoadingSection } = require('commonsComponents/loadingSection');

class TransfersAddBeneficiaryView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleTransferBeneficiary = this.handleTransferBeneficiary.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
    }

    componentDidMount() {
        const {
            match: { params: { beneficiaryId } },
            immBeneficiaries,
            requestBeneficiaries,
            fillBeneficiaryForm,
            history,
        } = this.props;

        if (beneficiaryId && !immBeneficiaries.getIn(['byId', beneficiaryId])) {
            //if is editing and the page reloads, redirect to agenda
            history.push('/myprofile/transfers/agenda');
        }

        requestBeneficiaries();

        if (beneficiaryId) {
            fillBeneficiaryForm(beneficiaryId);
        }
    }

    componentWillUnmount() {
        const { immAddBeneficiary, reset, resetLoadFromTransfer, resetBankName } = this.props;

        if (immAddBeneficiary.getIn(['steps', 0, 'isLoadingFromTransfer'])) {
            resetLoadFromTransfer();
        } else {
            reset();
        }
        resetBankName();
    }

    buildErrorState() {
        const errorMessage = formatText('transfersAgenda-errorTitleCreateNewBeneficiary');
        const errorSubMessage = <FormattedText value="transfersAgenda-errorCreateNewBeneficiary" />;
        const goBackButton = {
            label: formatText('transfersAgenda-addBeneficiarySuccessScreenButton').toUpperCase(),
            url: `/myprofile/transfers/agenda`
        };
        return (
            <article className="row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <WizardError
                        errorMessage={errorMessage}
                        errorSubMessage={errorSubMessage}
                        mainButton={goBackButton}
                    />
                </div>
            </article>
        );
    }

    buildLoadingState() {
        return (
            <div className="transfers-add-beneficiary-view__loading-state">
                <LoadingSection />
            </div>
        );
    }

    buildSuccessful() {
        const { immAddBeneficiary, immBeneficiaries } = this.props;

        return (
            <div className="row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <AddBeneficiarySuccessStep
                        immAddBeneficiary={immAddBeneficiary.getIn(['steps', 0])}
                        immBeneficiaries={immBeneficiaries}
                        onTransferBeneficiaryClick={this.handleTransferBeneficiary}
                    />
                </div>
            </div>
        );
    }

    handleConfirmLeave() {
        const { resetPrintedIndicators } = this.props
        resetPrintedIndicators()
    }

    buildWizard() {
        const { immAddBeneficiary, immBeneficiaries, immBankEntity, match: { params: { beneficiaryId } } } = this.props;

        const immSteps = immAddBeneficiary.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immAddBeneficiary.get('visibleStep');
        const wizardActions = {
            validateStep: beneficiaryId ? this.props.validateEditStep : this.props.validateStep,
            setVisibleStep: this.props.setVisibleStep,
            setWillCancel: this.props.setWillCancel,
            finish: beneficiaryId ? this.props.postEditBeneficiary : this.props.postBeneficiary,
            cancel: this.handleCancel
        };

        return (
            <Wizard
                actions={wizardActions}
                immSteps={immSteps}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                fullWidth={true}
                showPreLeaveModal={true}
                onConfirmLeave={__CONTACT_CENTER__ ? this.handleConfirmLeave : undefined}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    isLoading={immAddBeneficiary.get('isFetching')}
                >
                    <AddBeneficiaryStep1
                        immBeneficiaries={immBeneficiaries}
                        immAddBeneficiary={immAddBeneficiary}
                        immBankEntity={immBankEntity}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    addLoadingBehaviour={true}
                    cancelButton={true}
                    immFinalButton="common-confirm"
                    isLoading={immAddBeneficiary.get('isFetching')}
                >
                    <AddBeneficiaryStep2
                        beneficiaryId={beneficiaryId}
                        immAddBeneficiary={immAddBeneficiary.getIn(['steps', 0])}
                        immBankEntity={immBankEntity}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    handleCancel() {
        this.props.history.push('/myprofile/transfers/agenda');
    }

    handleTransferBeneficiary() {
        const { immAddBeneficiary, history } = this.props;
        const alias = immAddBeneficiary.getIn(['steps', 0, 'alias']);

        this.props.transferBeneficiary(alias, history);
    }

    render() {
        const { match: { params }, immBeneficiaries, immAddBeneficiary } = this.props;
        const beneficiaryId = params.beneficiaryId;
        const titleKey = beneficiaryId
            ? 'transfersAgenda-editBeneficiaryTitle'
            : 'transfersAgenda-addBeneficiaryTitle';

        let content;
        let titleStrings = [];
        if (beneficiaryId) {
            titleStrings = [immBeneficiaries.getIn(['byId', beneficiaryId, 'alias'])];
        }

        if (immBeneficiaries.get('error') || immAddBeneficiary.get('addBeneficiaryFailed')) {
            content = this.buildErrorState();
        } else if (immBeneficiaries.get('isFetching') && !immAddBeneficiary.get('submitSuccessful')) {
            content = this.buildLoadingState();
        } else if (immBeneficiaries.get('fetchSuccess')) {
            if (immAddBeneficiary.get('submitSuccessful')) {
                content = this.buildSuccessful();
            } else {
                content = this.buildWizard();
            }
        }
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-transfers'),
                url: '/myprofile/transfers'
            },
            {
                text: formatText('breadcrumb-agenda'),
                url: '/myprofile/transfers/agenda'
            },
            {
                text: formatText(titleKey, titleStrings),
                url: ''
            }
        ];

        return (
            <section className="transfers-add-beneficiary-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="transfers" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle(titleKey, titleStrings)}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid grid-view--content-position-negative">
                        {content}
                    </div>
                </div>
            </section>
        );
    }
}

TransfersAddBeneficiaryView.propTypes = {
    immBeneficiaries: PropTypes.object.isRequired,
    immBankEntity: PropTypes.object.isRequired,
    immAddBeneficiary: PropTypes.object.isRequired,
    requestBeneficiaries: PropTypes.func.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    transferBeneficiary: PropTypes.func.isRequired,
    fillBeneficiaryForm: PropTypes.func.isRequired,
    postBeneficiary: PropTypes.func.isRequired,
    validateEditStep: PropTypes.func.isRequired,
    postEditBeneficiary: PropTypes.func.isRequired,
    resetBankName: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetLoadFromTransfer: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    willLeave: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = TransfersAddBeneficiaryView;
module.exports.TransfersAddBeneficiaryView = connect(
    state => ({
        immBeneficiaries: state.beneficiaries,
        immAddBeneficiary: state.addBeneficiary,
        immBankEntity: state.bankEntity
    }),
    {
        requestBeneficiaries: beneficiariesActions.requestBeneficiaries,
        resetPrintedIndicators: printerActions.resetPrintedIndicators,
        transferBeneficiary: beneficiariesActions.transferBeneficiary,
        fillBeneficiaryForm: addBeneficiaryActions.fillBeneficiaryForm,
        postBeneficiary: addBeneficiaryActions.postBeneficiary,
        validateStep: addBeneficiaryActions.validateStep,
        setVisibleStep: addBeneficiaryActions.setVisibleStep,
        reset: addBeneficiaryActions.reset,
        resetLoadFromTransfer: addBeneficiaryActions.resetLoadFromTransfer,
        setWillCancel: addBeneficiaryActions.setWillCancel,
        willLeave: addBeneficiaryActions.setWillLeave,
        validateEditStep: addBeneficiaryActions.validateEditStep,
        postEditBeneficiary: addBeneficiaryActions.postEditBeneficiary,
        resetBankName: bankEntityActions.resetBankName
    }
)(withRouter(TransfersAddBeneficiaryView));
